import { ValuationsInputTable } from '@dealstack/frontend/app/pages/Valuations/views/EditValuation/ValuationsInputTable/ValuationsInputTable';
import {
	CreateValuationInputAdjustmentDto,
	CurrencyType,
	ValuationInputAdjustmentWithClassifierRes,
	ValuationInputWithAdjustmentsRes,
	ValuationNumberFormat,
} from '@dealstack/shared/lib/generated';
import { EmptyOwnershipStructure } from '@dealstack/frontend/app/pages/Valuations/views/EditValuation/ValuationsInputWrapper/EmptyOwnershipStructure';
import { ValuationTargetNodeList } from '@dealstack/frontend/app/pages/Valuations/views/EditValuation/ValuationTargetNodeList/ValuationTargetNodeList';
import { Grid } from '@mantine/core';
import { FormProvider } from 'react-hook-form';
import { HighPrecisionDecimal } from '@dealstack/shared/lib/format/currency/highPrecisionDecimal';
import { useValuationInputForm } from '@dealstack/frontend/app/pages/Valuations/views/EditValuation/ValuationsInputWrapper/useValuationInputForm';
import { ValuationInputsSavePayload } from '@dealstack/frontend/app/pages/Valuations/queries/useValuationInputsQuery';

interface ValuationsInputWrapperProps {
	valuationInputsRaw: ValuationInputWithAdjustmentsRes[];
	convertAmount: (amount: HighPrecisionDecimal, fromCurrency: string) => HighPrecisionDecimal;
	currentNumberFactor: number;
	valuationDate: string | undefined;
	defaultCurrency: CurrencyType | undefined;
	defaultNumberFormat: ValuationNumberFormat | undefined;
	saveFormSnapshot: (snapshot: ValuationInputsSavePayload) => void;
	createInputAdjustment: (params: {
		valuationInputId: string;
		data: CreateValuationInputAdjustmentDto;
	}) => Promise<ValuationInputAdjustmentWithClassifierRes | undefined>;
	deleteInputAdjustment: (params: {
		valuationInputAdjustmentId: string;
		valuationInputId: string;
	}) => void;
}

export const ValuationsInputWrapper = ({
	valuationInputsRaw,
	convertAmount,
	currentNumberFactor,
	valuationDate,
	defaultCurrency,
	defaultNumberFormat,
	saveFormSnapshot,
	createInputAdjustment,
	deleteInputAdjustment,
}: ValuationsInputWrapperProps) => {
	const {
		selectedValuationInputId,
		setSelectedValuationInputId,
		selectedValuationInputDetails,
		valuationInputDetails,
		inputAdjustmentTableForm,
	} = useValuationInputForm({
		valuationInputsRaw,
		convertAmount,
		currentNumberFactor,
		saveFormSnapshot,
	});

	if (!valuationInputDetails.length) {
		return <EmptyOwnershipStructure valuationDate={valuationDate} />;
	}

	return (
		<>
			{valuationInputDetails.length > 1 && (
				<Grid.Col span={3}>
					<ValuationTargetNodeList
						valuationInputDetails={valuationInputDetails}
						selectedValuationInputId={selectedValuationInputId}
						setSelectedValuationInputId={setSelectedValuationInputId}
						currentNumberFactor={currentNumberFactor}
					/>
				</Grid.Col>
			)}

			<Grid.Col span={9}>
				{selectedValuationInputId && selectedValuationInputDetails && (
					<FormProvider {...inputAdjustmentTableForm}>
						<ValuationsInputTable
							selectedValuationInputId={selectedValuationInputId}
							selectedValuationInputDetails={selectedValuationInputDetails}
							defaultCurrency={defaultCurrency!}
							defaultNumberFormat={defaultNumberFormat!}
							currentNumberFactor={currentNumberFactor}
							createInputAdjustment={createInputAdjustment}
							deleteInputAdjustment={deleteInputAdjustment}
						/>
					</FormProvider>
				)}
			</Grid.Col>
		</>
	);
};
